import React, { Component } from 'react';
import WorkFlowTemplate from '../common/workFlowTemplate'
import SideNav from './SideNav';

class WorkFlowHospital extends Component {
    render() {
        return (
            <div className="content">
                <SideNav selectKey='detail' />
                <div className="main">
                    <WorkFlowTemplate showEdit={true} showReference={true} />
                </div>  
            </div>
        );
    }
}

export default WorkFlowHospital;


// WEBPACK FOOTER //
// ./src/components/hospital/WorkFlowHospital.js